// Built-ins
import React from "react";

// Icons-images
import { BsInfoSquare } from "react-icons/bs";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdCreditCard } from "react-icons/md";
import { FaHashtag, FaCheck, FaGlobe } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdAlternateEmail } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { FaMinus } from "react-icons/fa";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { GiConvergenceTarget } from "react-icons/gi";
import { BsMailbox } from "react-icons/bs";
import { IoMdBusiness } from "react-icons/io";

// Functions / modules
import axios from "axios";
import { Card } from "react-bootstrap";
import { Grid } from "semantic-ui-react";
import Swal from "sweetalert2";

// Custom Made Components
import ChangeName from "../../../modals/change_name";
import ChangeAddress from "../../../modals/change_address";
import Notes from "../../../core/notes/notes";
import ChangeEmail from "../../../modals/change_email";
import ChangeTel from "../../../modals/change_tel";
import ChangeWebsite from "../../../modals/change_website";
import DeleteObjectModal from "../../../modals/delete_object";
import ChangeLatLng from "../../../modals/change_lat_lng";
import ChangeEnabled from "../../../modals/change_enabled";
import GoogleMap from "../../../core/map/map";
import EditPaymentDetails from "../../../modals/edit_payment_details";
import ContactPersons from "../../../core/contact_persons/contact_persons";
import ChangeAddress2 from "../../../modals/change_address2";
import ChangePostal from "../../../modals/change_postal";
import ChangeRegion from "../../../modals/change_region";
import ChangePrice from "../../../modals/change_price";

// Global Variables
import {
  headers,
  loader,
  pageHeader,
  forbidden,
  restrictedUsers,
  iconStyle,
} from "../../../global_vars";

// Variables
window.Swal = Swal;

let overviewIconStyle = { color: "#F3702D", marginRight: "0.5em" };

const VIEW_DISTILLERY = "https://groupplan.gr/api/data_management/distillery/";

function getDistilleryId() {
  return window.location.pathname.split("/")[3];
}

// url path = 'http://localhost:3000/distillery/1'
class DistilleryOverView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      distillery: {
        notes: [],
      },
      contact_persons: [],
      is_loaded: false,
      forbidden: false,
      show_tel2: false,
      show_address2: false,
    };
  }

  componentDidMount() {
    if (restrictedUsers().includes(localStorage.getItem("user"))) {
      this.setState({
        forbidden: true,
      });
    }
    headers["Authorization"] = "Token " + localStorage.getItem("userToken");
    axios
      .get(VIEW_DISTILLERY + getDistilleryId(), {
        headers: headers,
      })
      .then((res) => {
        const distillery = res.data.distillery || {};
        this.setState({
          distillery: {
            ...distillery,
            contact: distillery.contact || {},
            payment_details: distillery.payment_details || {},
            notes: distillery.notes || [],
            contact_persons: distillery.contact_persons || [],
          },
          contact_persons: distillery.contact_persons || [],
          notes: distillery.notes || [],
          is_loaded: true,
        });
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            forbidden: true,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unknown error has occured.",
          });
        }
      });
  }

  update_state = (update_state) => {
    this.setState({ distillery: update_state });
  };

  update_notes = (notes) => {
    var distillery = { ...this.state.distillery };
    distillery.notes = notes;
    this.setState({
      distillery: distillery,
    });
  };

  add_contact_person = (contact_persons) => {
    var distillery = { ...this.state.distillery };
    distillery.contact_persons = contact_persons;
    this.setState({
      distillery: distillery,
      contact_persons: contact_persons,
    });
  };

  render() {
    return (
      <>
        <div className="mainContainer">
          {pageHeader("distillery_overview", this.state.distillery.name)}
          {this.state.forbidden ? (
            <>{forbidden("Updates")}</>
          ) : this.state.is_loaded ? (
            <>
              <Grid stackable columns={2} divided>
                <Grid.Column>
                  <Card>
                    <Card.Header>
                      <BsInfoSquare
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Distillery Information
                    </Card.Header>
                    <Card.Body>
                      <div className={"info_descr"}>
                        <FaHashtag style={overviewIconStyle} /> Name
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.name
                          ? this.state.distillery.name
                          : "N/A"}
                      </div>

                      <ChangeName
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                      />

                      <div className={"info_descr"}>
                        <MdCreditCard style={overviewIconStyle} /> Price
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.price !== null &&
                        this.state.distillery.price !== undefined &&
                        this.state.distillery.price !== ""
                          ? `${this.state.distillery.currency || ""} ${
                              this.state.distillery.price
                            }`.trim()
                          : "N/A"}
                      </div>
                      <ChangePrice
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        price={this.state.distillery.price}
                        currency={this.state.distillery.currency}
                      />

                      <div className={"info_descr"}> <IoMdBusiness style={overviewIconStyle} /> Company </div>
                      <div className={"info_span"}>
                        {this.state.distillery.payment_details
                          ? this.state.distillery.payment_details.company === "" ||
                            this.state.distillery.payment_details.company === null
                            ? "N/A"
                            : 
                            <span style={{color: this.state.distillery.payment_details.company === this.state.distillery.name ? 'blue': ''}}>
                              {this.state.distillery.payment_details.company}
                            </span>
                          : "N/A"}
                      </div>

                      <div className={"info_descr"}>
                        <FaMapMarkerAlt style={overviewIconStyle} />
                        Lat / Lng
                      </div>
                      <ChangeLatLng
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        lat={this.state.distillery.lat}
                        lng={this.state.distillery.lng}
                      />
                      <div className={"lat_lng_span"}>
                        {this.state.distillery.lat
                          ? this.state.distillery.lat
                          : "N/A"}
                      </div>
                      <div
                        style={{ marginLeft: 35 }}
                        className={"lat_lng_span"}
                      >
                        {this.state.distillery.lng
                          ? this.state.distillery.lng
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}>
                        <FaAddressCard style={overviewIconStyle} /> Address
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.contact.address
                          ? this.state.distillery.contact.address
                          : "N/A"}
                      </div>
                      <ChangeAddress
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        address={
                          this.state.distillery.contact.address
                            ? this.state.distillery.contact.address
                            : "N/A"
                        }
                      />

                      {this.state.show_address2 ? (
                        <>
                          <div className={"info_descr"}>
                            <FaAddressCard style={overviewIconStyle} /> Address
                            2
                          </div>
                          <div className={"info_span"}>
                            {this.state.distillery.contact.address2
                              ? this.state.distillery.contact.address2
                              : "N/A"}
                          </div>
                          <FaMinus
                            className="minus-icon"
                            title="Hide address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() =>
                              this.setState({ show_address2: false })
                            }
                          />
                          <ChangeAddress2
                            object_id={this.state.distillery.id}
                            object_name={this.state.distillery.name}
                            object_type={"Distillery"}
                            update_state={this.update_state}
                            address={
                              this.state.distillery.contact.address2
                                ? this.state.distillery.contact.address2
                                : "N/A"
                            }
                          />
                        </>
                      ) : (
                        <>
                          <AiOutlinePlusSquare
                            className="plus-icon"
                            title="Show Address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() =>
                              this.setState({ show_address2: true })
                            }
                          />
                        </>
                      )}

                      <div className={"info_descr"}>
                        <BsFillTelephoneFill style={overviewIconStyle} /> Tel
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.contact.tel
                          ? this.state.distillery.contact.tel
                          : "N/A"}
                      </div>
                      <ChangeTel
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        tel_num={"tel"}
                        update_state={this.update_state}
                        telephone={
                          this.state.distillery.contact.tel
                            ? this.state.distillery.contact.tel
                            : "N/A"
                        }
                      />
                      {this.state.show_tel2 ? (
                        <>
                          <div className={"info_descr"}>
                            <BsFillTelephoneFill style={overviewIconStyle} />
                            Tel. 2
                          </div>
                          <div className={"info_span"}>
                            {this.state.distillery.contact.tel2
                              ? this.state.distillery.contact.tel2
                              : "N/A"}
                          </div>

                          <ChangeTel
                            object_id={this.state.distillery.id}
                            object_name={this.state.distillery.name}
                            object_type={"Distillery"}
                            tel_num={"tel2"}
                            update_state={this.update_state}
                            telephone={
                              this.state.distillery.contact.tel2
                                ? this.state.distillery.contact.tel2
                                : "N/A"
                            }
                          />
                          <div className={"info_descr"}>
                            <BsFillTelephoneFill style={overviewIconStyle} />
                            Tel. 3
                          </div>
                          <div className={"info_span"}>
                            {this.state.distillery.contact.tel3
                              ? this.state.distillery.contact.tel3
                              : "N/A"}
                          </div>

                          <FaMinus
                            className="minus-icon"
                            title="Hide address 2"
                            style={{ marginLeft: 20 }}
                            onClick={() => this.setState({ show_tel2: false })}
                          />

                          <ChangeTel
                            object_id={this.state.distillery.id}
                            object_name={this.state.distillery.name}
                            object_type={"Distillery"}
                            tel_num={"tel3"}
                            update_state={this.update_state}
                            telephone={
                              this.state.distillery.contact.tel3
                                ? this.state.distillery.contact.tel3
                                : "N/A"
                            }
                          />
                        </>
                      ) : (
                        <>
                          <AiOutlinePlusSquare
                            className="plus-icon"
                            title="Show Tel 2"
                            style={{ marginLeft: 20 }}
                            onClick={() => this.setState({ show_tel2: true })}
                          />
                        </>
                      )}

                      <div className={"info_descr"}>
                        <GiConvergenceTarget style={overviewIconStyle} /> Region
                      </div>

                      <div className={"info_span"}>
                        {this.state.distillery.region ? this.state.distillery.region : 'N/A'}
                      </div>

                      <ChangeRegion
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                      />

                      <div className={"info_descr"}>
                        <BsMailbox style={overviewIconStyle} />
                        Postal / Zip code
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.contact.postal
                          ? this.state.distillery.contact.postal
                          : "N/A"}
                      </div>
                      <ChangePostal
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        postal={
                          this.state.distillery.contact.postal
                            ? this.state.distillery.contact.postal
                            : "N/A"
                        }
                      />
                      <div className={"info_descr"}>
                        <MdAlternateEmail style={overviewIconStyle} />
                        Email
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.contact.email
                          ? this.state.distillery.contact.email
                          : "N/A"}
                      </div>
                      <ChangeEmail
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        email={
                          this.state.distillery.contact.email
                            ? this.state.distillery.contact.email
                            : "N/A"
                        }
                      />
                      <div className={"info_descr"}>
                        <FaGlobe style={overviewIconStyle} /> Website
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.contact.website
                          ? this.state.distillery.contact.website
                          : "N/A"}
                      </div>
                      <ChangeWebsite
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        website={
                          this.state.distillery.contact.website
                            ? this.state.distillery.contact.website
                            : "N/A"
                        }
                      />
                      <ContactPersons
                        add_contact_person={this.add_contact_person}
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        contact_persons={this.state.distillery.contact_persons}
                      />
                      <div className={"info_descr"}>
                        {this.state.distillery.enabled ? (
                          <FaCheck style={overviewIconStyle} />
                        ) : (
                          <ImCross style={overviewIconStyle} />
                        )}
                        Enabled
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.enabled ? "Enabled" : "Disabled"}
                      </div>
                      <ChangeEnabled
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                      />
                    </Card.Body>
                    <Card.Footer>
                      <DeleteObjectModal
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                      />
                    </Card.Footer>
                  </Card>
                  <Notes
                    update_notes={this.update_notes}
                    object_id={this.state.distillery.id}
                    object_name={this.state.distillery.name}
                    object_type={"Distillery"}
                    update_state={this.update_state}
                    notes={this.state.distillery.notes}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Card>
                    <Card.Header>
                      <FaMapMarkerAlt
                        style={{
                          color: "#F3702D",
                          fontSize: "1.5em",
                          marginRight: "0.5em",
                        }}
                      />
                      Map with distillery's location
                    </Card.Header>
                    {this.state.distillery.lat || this.state.distillery.lng ? (
                      <>
                        <Card.Body>
                          <GoogleMap object={this.state.distillery} />
                        </Card.Body>
                      </>
                    ) : (
                      <strong
                        style={{
                          textAlign: "center",
                          margin: 20,
                          padding: 20,
                        }}
                      >
                        Update latitude / longitude to show distillery\'s location
                        on map
                      </strong>
                    )}
                    <Card.Footer>
                      <small className="mr-auto">
                        <BsInfoSquare
                          style={{
                            color: "#F3702D",
                            fontSize: "1.5em",
                            marginRight: "0.5em",
                          }}
                        />
                        Changing distillery's lat/lng will also change the map's
                        pin
                      </small>
                    </Card.Footer>
                  </Card>

                  <Card>
                    <Card.Header>
                      <MdCreditCard style={iconStyle} />
                      Payment Details
                    </Card.Header>
                    <Card.Body>
                      <div className={"info_descr"}> Company </div>
                      <div className={"info_span"}>
                        {this.state.distillery.payment_details
                          ? this.state.distillery.payment_details.company === "" ||
                            this.state.distillery.payment_details.company === null
                            ? "N/A"
                            : this.state.distillery.payment_details.company
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}> Currency </div>
                      <div className={"info_span"}>
                        {this.state.distillery.payment_details
                          ? this.state.distillery.payment_details.currency ===
                              "" ||
                            this.state.distillery.payment_details.currency === null
                            ? "N/A"
                            : this.state.distillery.payment_details.currency
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}>
                        {this.state.distillery.payment_details &&
                        this.state.distillery.payment_details.currency === "GBP"
                          ? "Account Number"
                          : "IBAN"}
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.payment_details
                          ? this.state.distillery.payment_details.iban === "" ||
                            this.state.distillery.payment_details.iban === null
                            ? "N/A"
                            : this.state.distillery.payment_details.iban
                          : "N/A"}
                      </div>
                      <div className={"info_descr"}>
                        {this.state.distillery.payment_details &&
                        this.state.distillery.payment_details.currency === "GBP"
                          ? "Sort Code"
                          : "Swift"}
                      </div>
                      <div className={"info_span"}>
                        {this.state.distillery.payment_details
                          ? this.state.distillery.payment_details.swift === "" ||
                            this.state.distillery.payment_details.swift === null
                            ? "N/A"
                            : this.state.distillery.payment_details.swift
                          : "N/A"}
                      </div>
                    </Card.Body>
                    <Card.Footer>
                      <EditPaymentDetails
                        object_id={this.state.distillery.id}
                        object_name={this.state.distillery.name}
                        object_type={"Distillery"}
                        update_state={this.update_state}
                        payment_details={this.state.distillery.payment_details}
                      />
                    </Card.Footer>
                  </Card>
                </Grid.Column>
              </Grid>
            </>
          ) : (
            loader()
          )}
        </div>
      </>
    );
  }
}

export default DistilleryOverView;
